import React,{useContext} from 'react'
import {themeContext} from '../../Context'

import './Skills.css'
import frontendskills from './frontendskills.js'
const Skills = () => {
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode;
  return (
    <div className={`skills_wrapper d-flex ${darkMode ? 'skills_wrapper_dark':'skills_wrapper_light'}`}>
      <div className="frontend_skill">
        {
          frontendskills.map((item, index) => (
            <div key={index} className="skill_data mb-3">
              <div className={`${darkMode?'skill_title_dark':'skill_title_light'} d-flex align-items-center justify-content-between`}>
                <h6 > {item.title} </h6 >
                <span > {item.percentage} </span >
              </div >
              <div className="skill_bar">
                <span className={`skill_bar-percentage ${darkMode ? 'skill_bar-percentage_dark': 'skill_bar-percentage_light'}`} style={{width: `${item.percentage}`}}> </span >
              </div >
            </div >
          ))
        }
      </div>
    </div>
  )
}

export default Skills